import React from 'react'
import { useState, useEffect, useContext } from 'react'
import { Route, Routes } from 'react-router-dom'
import UserContext from './store/user-context'
import CustomNav from './layout/CustomNav'
import NewType from './pages/NewType'
import Auth from './pages/Auth'
import SignUp from './components/SignUp'
import SignIn from './components/SignIn'
import Loader from './components/Loader'
import { DataContextProvider } from './store/data-context'
import { toast } from 'react-toastify'

function Router() {
    const { userState: { isAuth }, setUserState } = useContext(UserContext);
    const [isLoaded, setIsLoaded] = useState(false)

    const logOutBtnHandler = (showToast = false) => {
        if (showToast)
            toast.success('User logged out successfully')
        localStorage.removeItem('token');
        localStorage.removeItem('expiryDate');
        localStorage.removeItem('userId');
        setUserState({ isAuth: false, token: null, userId: null })
    }

    useEffect(() => {
        setIsLoaded(false)
        const token = localStorage.getItem('token');
        const expiryDate = localStorage.getItem('expiryDate');
        const userId = localStorage.getItem('userId');
        if (!token || !expiryDate || !userId || (new Date(expiryDate) <= new Date())) {
            logOutBtnHandler()
            setIsLoaded(true)
            return
        }
        setUserState({ isAuth: true, token: token, userId: userId })
        setIsLoaded(true)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setUserState])

    return (
        <>
            {isLoaded
                ? <Routes>
                    {isAuth
                        ?
                        <Route path='/' element={<DataContextProvider><CustomNav logOutBtnHandler={logOutBtnHandler} /> </DataContextProvider>} >
                            <Route index element={<NewType />} />
                        </Route>
                        : <Route path='/' element={<Auth />}>
                            <Route index element={<SignIn />} />
                            <Route path='signup' element={<SignUp />} />
                        </Route>
                    }
                    <Route
                        path='*'
                        element={
                            <div className='heading'>
                                <h1>There's nothing here!</h1>
                            </div>
                        }
                    />
                </Routes>
                : <div className='center-screen'><Loader /></div>}
        </>
    )
}

export default Router